<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <button class="close-button" (click)="onClose()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="#101223" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Image -->
    <div class="modal-image">
      <div class="illustration">
        <!-- Error illustration - person with surprised expression and exclamation marks -->
        <img src="/assets/images/package/Illustrations.svg" alt="Cancellation Error" class="illustration-image">
      </div>
    </div>

    <!-- Text Content -->
    <div class="modal-text">
      <h2 class="modal-title">Cancellation failed!</h2>
      <p class="modal-description">
        Something went wrong while cancelling the appointment. Try again or reach out to our support team for assistance.
      </p>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="button-container">
        <button class="btn btn-primary" (click)="onOkay()">
          Okay
        </button>
      </div>
    </div>
  </div>
</div>
